/** Overview tab - summary cards for the Supplier Profile screen header data. */

import { Box, Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Section } from '../../../../../components/ui/Section';
import { SupplierDirectoryEntry } from '../../../../../mocks/data/supplierProfileData';

export interface OverviewTabProps {
  directoryEntry: SupplierDirectoryEntry;
  assignedSitesCount: number;
  activeCataloguesCount: number;
  openExceptionsCount: number;
  certificationStatus: string;
}

const SummaryCard = ({ label, value }: { label: string; value: string | number }) => (
  <Grid item
    xs={12}
    sm={6}
    md={4}
    lg={3}>
    <Box sx={{ p: 2 }}>
      <Typography variant="textXS"
        color="text.secondary">{label}</Typography>
      <Typography variant="textMD"
        fontWeight={600}>{value}</Typography>
    </Box>
  </Grid>
);

const OverviewTab: React.FC<OverviewTabProps> = ({
  directoryEntry, assignedSitesCount, activeCataloguesCount, openExceptionsCount, certificationStatus,
}) => {
  const { t } = useTranslation('suppliers');

  return (
    <Section>
      <Grid container>
        <SummaryCard label={t('supplierCategory', 'Supplier category')}
          value={directoryEntry.supplierCategory} />
        <SummaryCard label={t('supplierType', 'Supplier type')}
          value={directoryEntry.supplierType} />
        <SummaryCard label={t('coverageType', 'Coverage type')}
          value={directoryEntry.coverageType} />
        <SummaryCard label={t('assignedSites', 'Assigned sites')}
          value={assignedSitesCount} />
        <SummaryCard label={t('activeCatalogues', 'Active catalogues')}
          value={activeCataloguesCount} />
        <SummaryCard label={t('openExceptions', 'Open exceptions')}
          value={openExceptionsCount} />
        <SummaryCard label={t('certificationStatus', 'Certification status')}
          value={certificationStatus} />
        <SummaryCard label={t('lastReviewDate', 'Last review date')}
          value={directoryEntry.lastReviewDate ?? t('notCaptured', 'Not captured')} />
        <SummaryCard label={t('nextReviewDate', 'Next review date')}
          value={directoryEntry.nextReviewDate ?? t('notCaptured', 'Not captured')} />
        <SummaryCard label={t('primaryContact', 'Primary contact')}
          value={t('seeContactsTab', 'See Contacts tab')} />
      </Grid>
    </Section>
  );
};

export default OverviewTab;
